import { useHistory } from 'react-router-dom';
import queryString from 'query-string';

import { qsParseNoArray } from 'client/utils/queryString';

export default function useRemoveAndRetrieveQs() {
    const history = useHistory();

    return (qsArray = []) => {
        const qsObj = qsParseNoArray(window.location.search);
        const { rest, retrieved } = Object.entries(qsObj).reduce(
            (obj, [key, val]) => {
                if (qsArray.includes(key)) {
                    obj.retrieved[key] = val;
                } else {
                    obj.rest[key] = val;
                }
                return obj;
            },
            { retrieved: {}, rest: {} }
        );
        if (Object.keys(retrieved).length > 0) {
            const qs = queryString.stringify(rest);
            history.replace(`${history.location.pathname}${qs ? `?${qs}` : ''}`);
        }
        return { rest, retrieved };
    };
}
